import React from "react";
import "./Share.css";
import ShareIcon from "@mui/icons-material/Share";

function Share({ title, introduction }) {
  // URL pointing to the root endpoint of your backend server
  const url = introduction
    ? `http://localhost:3001/${encodeURIComponent(
        introduction
      )}?message=hello%20world`
    : "http://localhost:3001/?message=hello%20world";

  const handleShare = async () => {
    try {
      if (navigator.share) {
        await navigator.share({
          title: title,
          url: url,
        });
      } else {
        throw new Error("Web Share API not supported");
      }
    } catch (error) {
      console.error("Error sharing:", error);
      // Fallback for unsupported browsers
      alert("Share functionality is not supported in this browser.");
    }
  };

  return (
    <>
      <button
        style={{ outline: "none" }}
        onClick={handleShare}
        className="Share"
      >
        <ShareIcon />
      </button>
    </>
  );
}

export default Share;
